<template>
    <div class="terms">
        <Header headTitle="이용 약관" isShowBackBtn @clickBack="cancel" />

        <div class="detail-page">
            <Terms />
        </div>
    </div>
</template>

<script>
import Terms from "@/_bayer/commonComp/policy/Terms.vue";
import Header from "@/_bayer/commonComp/Header.vue";
export default {
    components: {
        Terms,
        Header
    },
    methods: {
        cancel() {

        }
    }
}
</script>

<style lang="scss">
.terms {
    .detail-page {
        .agree-content {
            width: 90vw;
            margin: 0 auto;
        }
    }
}
</style>